<template>
  <div
    class="mt-5 d-flex flex-column justify-content-center align-items-center"
  >
    <b-card-title
      title-tag="h2"
      class="font-weight-bold mb-1 text-center mt-2"
    >
      {{ $t('dashboard.no-pages-accounts') }}
    </b-card-title>
    <b-card-text class="mb-4 text-center">
      {{ $t('auth.welcome-hint') }}
    </b-card-text>
    <error-alert
      v-if="error"
      :error="error"
    />

    <!-- Facebook Section -->
    <div
      class="mb-4 text-center"
      style="width: 100%; max-width: 400px;"
    >
      <h4 class="font-weight-bold mb-2">
        {{ $t('dashboard.connect-facebook-title') }}
      </h4>
      <p class="mb-3 text-muted">
        {{ $t('dashboard.connect-facebook-description') }}
      </p>
      <b-button
        class="btn-facebook"
        :disabled="loading"
        @click="authFacebook(false)"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-1"
        />
        <feather-icon
          icon="FacebookIcon"
          class="mr-50"
        />
        <span>{{ $t('page.connect-facebook-page') }}</span>
      </b-button>
    </div>

    <!-- Instagram Section -->
    <div
      v-if="showInstagram"
      class="text-center"
      style="width: 100%; max-width: 400px;"
    >
      <h4 class="font-weight-bold mb-2">
        {{ $t('dashboard.connect-instagram-title') }}
      </h4>
      <p class="mb-3 text-muted">
        {{ $t('dashboard.connect-instagram-description') }}
      </p>
      <b-button
        :disabled="loading"
        class="btn-instagram-gradient"
        style="margin: 0 auto;"
        @click="authInstagramDirect(false)"
      >
        <b-spinner
          v-if="loading"
          small
          class="mr-1"
        />
        <feather-icon
          icon="InstagramIcon"
          class="mr-50 mt-50"
        />
        <span>{{ $t('instagram.connect-instagram-account') }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>

import AuthMixin from '@/views/auth/mixins/auth-mixin'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import {
  BCardText, BCardTitle, BButton, BSpinner,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'NoAccountPage',
  components: {
    ErrorAlert,
    BCardText,
    BCardTitle,
    BButton,
    BSpinner,
  },
  mixins: [AuthMixin],
  computed: {
    ...mapGetters({
      showInstagram: 'auth/showInstagram',
    }),
  },
}
</script>
